import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class GetTokenShineService {
  COMPANY_ROUTE_API = 'api/v2.0/companies';
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly configService: ConfigurationService = inject(ConfigurationService);

  public getTokenForShineRedirection(domainId: string): Observable<{ token: string }> {
    return this.httpClient.get<{ token: string }>(
      `${this.configService.urlApiSiVision}/${this.COMPANY_ROUTE_API}/${domainId}/jwtEs265`,
    );
  }
}
